import { z } from 'zod';
import { defineDataSource } from '@/shared/page';
import { can } from '@/shared/screen';
import { getCurrentTenant } from '@/shared/http';
import { listBillings, getBilling } from './billing.api';
import { billingSchema } from './billing.wire';
import { billingKeys } from './billing.queries';
import { billingFilters } from './billing.filters';
export const billingListParams = z.object({
  selected: z.array(z.string()).default([]),
  page: z.number().default(0),
  size: z.number().default(5),
  filters: z.record(z.string(), z.union([z.string(), z.array(z.string())])).default({}),
});
export const billingListSource = defineDataSource({
  id: 'billing.list',
  description: 'Billing page in the current tenant.',
  shape: 'page',
  params: billingListParams,
  response: billingSchema,
  permission: can('BillingAccount', 'Read'),
  sensitivity: 'internal',
  limits: { staleTimeMs: 30000 },
  key: (p) =>
    billingKeys.list({
      page: p.page,
      size: p.size,
      filters: p.filters,
      tenant: getCurrentTenant(),
    }),
  fetch: async (p, { signal }) => {
    const result = await listBillings(
      {
        ...billingFilters.toParams(p.filters),
        page: p.page,
        size: p.size,
        tenant: getCurrentTenant(),
      },
      signal,
    );
    return { items: result.data, total: result.totalItems, pageCount: result.totalPages };
  },
});
export const billingDetailParams = z.object({ id: z.string() });
export const billingDetailSource = defineDataSource({
  id: 'billing.detail',
  description: 'One billing record.',
  shape: 'record',
  params: billingDetailParams,
  response: billingSchema,
  permission: can('BillingAccount', 'Read'),
  sensitivity: 'restricted',
  limits: { staleTimeMs: 30000 },
  key: (p) => billingKeys.detail(p.id),
  fetch: (p, { signal }) => getBilling(p.id, signal),
});
